import React from 'react';
import {EventNames, EventProperty, ScreenNames} from 'src/lib/analytics/events';
import Tracker from 'src/lib/analytics/tracker';

type ScreenHeaderPropsBase = {
    icon: React.ReactNode;
    className?: string;
};

type ScreenHeaderPropsWithTitle = ScreenHeaderPropsBase & {
    title: string;
};

type ScreenHeaderPropsWithChildren = ScreenHeaderPropsBase & {
    children: React.ReactNode;
};

type ScreenHeaderProps = ScreenHeaderPropsWithTitle | ScreenHeaderPropsWithChildren;

function ScreenHeader(props: ScreenHeaderProps) {
    return (
        <div className={'flex flex-row items-center p-5 ' + (props.className ?? '')}>
            <div className={'mr-4 inline-block rounded-lg bg-gray-200 p-3'}>{props.icon}</div>
            {'title' in props && <span className={'font-semibold'}>{props.title}</span>}
            {'children' in props && <>{props.children}</>}
        </div>
    );
}

function ScreenDivider() {
    return <hr className={'my-px block h-px border-0 border-t border-solid border-t-gray-200 p-0'} />;
}

const BaseScreenStyle = {
    default: 'm-7 flex flex-col',
    border: 'm-7 border border-solid border-gray-200 rounded-lg flex flex-col',
};

function BaseScreen(props: {
    children?: React.ReactNode;
    className?: string;
    screenName?: ScreenNames;
    border?: boolean;
}) {
    const mut = React.useRef(false);
    React.useEffect(() => {
        if (!mut.current && props.screenName) {
            mut.current = true;
            Tracker.setCurrentScreenName(props.screenName);
            Tracker.trackEvent(EventNames.SCREEN_VIEWS, {
                [EventProperty.ScreenName]: props.screenName,
            });
        }
    });

    return (
        <div
            className={
                (props.border ?? true ? BaseScreenStyle.border : BaseScreenStyle.default) +
                ' ' +
                (props.className ?? '')
            }>
            {props.children}
        </div>
    );
}

export {ScreenHeader, ScreenDivider, BaseScreen};
